import React from "react";

function Gift() {
  return (
    <div className="mx-2">
  <div
    id="default-carousel"
    className="relative w-full h-full cursor-pointer mx-auto rounded-xl shadow-lg my-8 overflow-hidden"
  >
    <img
      src="./img/magneto.webp"
      alt="Hero Banner"
      className="w-full h-full object-cover"
    />
  </div>
</div>

  );
}

export default Gift;
